import styled from 'styled-components/native'
import { Keyboard, Platform, TouchableWithoutFeedback, StatusBar } from 'react-native'
import { atlTheme } from '../atlTheme'
import React from 'react'
import { PersonalizedAwareScrollView } from './PersonalizedAwareScrollView'

const isPlatformIos = Platform.OS === 'ios'

const LightBackground = styled.SafeAreaView`
  background-color: ${atlTheme.ColorSurface};
  flex: 1;
`

export const LightGrayBackground = styled.SafeAreaView`
  background-color: ${atlTheme.ColorBackground};
  flex: 1;
`

const WarningBackground = styled.SafeAreaView`
  background-color: ${atlTheme.ColorBrand2Low};
  flex: 1;
`

const DarkBackground = styled.SafeAreaView`
  background-color: ${atlTheme.ColorBrand1Default};
  flex: 1;
`

const KeyboardAvoiding = styled.KeyboardAvoidingView`
  flex: 1;
  flex-direction: column;
  justify-content: center;
`

export const GrayBackgroundBase: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorBackground} barStyle="dark-content" />
      <LightGrayBackground>{children}</LightGrayBackground>
    </>
  )
}

export const LightScreenView: React.FunctionComponent = ({ children }) => {
  if (isPlatformIos) {
    return (
      <>
        <StatusBar backgroundColor={atlTheme.ColorSurface} barStyle="dark-content" />
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
          <KeyboardAvoiding behavior={'padding'} enabled keyboardVerticalOffset={-128}>
            <LightBackground>{children}</LightBackground>
          </KeyboardAvoiding>
        </TouchableWithoutFeedback>
      </>
    )
  } else {
    return (
      <>
        <StatusBar backgroundColor={atlTheme.ColorSurface} barStyle="dark-content" />
        <KeyboardAvoiding behavior={'padding'} enabled keyboardVerticalOffset={-128}>
          <LightBackground>{children}</LightBackground>
        </KeyboardAvoiding>
      </>
    )
  }
}

export const LightGrayScreenScrollView: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorBackground} barStyle="dark-content" />
      <PersonalizedAwareScrollView>
        <LightGrayBackground>{children}</LightGrayBackground>
      </PersonalizedAwareScrollView>
    </>
  )
}

export const LightScreenScrollView: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorSurface} barStyle="dark-content" />
      <PersonalizedAwareScrollView>
        <LightBackground>{children}</LightBackground>
      </PersonalizedAwareScrollView>
    </>
  )
}

export const DarkBackgroundView: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorBrand1Default} barStyle="light-content" />
      <DarkBackground>{children}</DarkBackground>
    </>
  )
}

export const DarkScreenView: React.FunctionComponent = ({ children }) => {
  if (isPlatformIos) {
    return (
      <>
        <StatusBar backgroundColor={atlTheme.ColorBrand1Default} barStyle="light-content" />
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
          <KeyboardAvoiding behavior={'padding'} enabled keyboardVerticalOffset={-128}>
            <DarkBackground>{children}</DarkBackground>
          </KeyboardAvoiding>
        </TouchableWithoutFeedback>
      </>
    )
  } else {
    return (
      <>
        <StatusBar backgroundColor={atlTheme.ColorBrand1Default} barStyle="light-content" />
        <KeyboardAvoiding behavior={'padding'} enabled keyboardVerticalOffset={-128}>
          <DarkBackground>{children}</DarkBackground>
        </KeyboardAvoiding>
      </>
    )
  }
}

export const DarkScreenScrollView: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorBrand1Default} barStyle="light-content" />
      <PersonalizedAwareScrollView>
        <DarkBackground>{children}</DarkBackground>
      </PersonalizedAwareScrollView>
    </>
  )
}

export const WarningScreenScrollView: React.FunctionComponent = ({ children }) => {
  return (
    <>
      <StatusBar backgroundColor={atlTheme.ColorBrand2Low} barStyle="dark-content" />
      <PersonalizedAwareScrollView>
        <WarningBackground>{children}</WarningBackground>
      </PersonalizedAwareScrollView>
    </>
  )
}
